export enum COMPLIANCE_RESOLUTION {
    ACCEPT = 'ACCEPT',
    DISPOSE = 'DISPOSE',
    TRIM = 'TRIM',
    NONE = 'NONE',
}
